<template>
  <div>
    <input type="hidden" v-model.trim="item" />
    <p class="title">{{ item }}</p>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "InputHidden",
  props: {
    label: String,
    title: String,
    tag: String,
    color: String,
    value: String,
    prefix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      item: this.value,
    };
  },
  watch: {
    item: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.item = val;
    },
  },
};
</script>
